import React from 'react'
import { useTranslation } from 'react-i18next'
import * as R from 'remeda'

import { useSurveyQueryQuestions } from '~/hooks/useSurveyQuery'
import { type SurveyFilterGroups, surveyFilterToText } from '~/utils'

import { useAvailableBrandGroups } from './useAvailableBrandGroups'
import { useAvailableCustomerAttributeGroups } from './useAvailableCustomerAttributeGroups'

export const useFilterGroupsToText = () => {
  const brandGroups = useAvailableBrandGroups()
  const questions = useSurveyQueryQuestions()
  const customerAttributeGroups = useAvailableCustomerAttributeGroups(undefined)
  const { t } = useTranslation()

  return React.useCallback(
    (filterGroups: SurveyFilterGroups) =>
      R.first(filterGroups)
        ?.map((filter) =>
          surveyFilterToText({
            brandGroups,
            customerAttributeGroups,
            filter,
            questions,
            t,
          }),
        )
        .join(' AND '),
    [brandGroups, customerAttributeGroups, questions, t],
  )
}
